import React from "react";

export default function VisaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 15"
      fill="none"
    >
      <path
        d="M1.88348 0.242004H18.1188C19.0482 0.242004 19.7894 0.983181 19.7894 1.90083V12.1832C19.7894 13.1008 19.0482 13.8538 18.1305 13.8538H1.87171C0.954067 13.8538 0.212891 13.1008 0.212891 12.1832V1.91259C0.212891 0.983181 0.942302 0.242004 1.87171 0.242004H1.88348Z"
        fill="white"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="0.588235"
      />
      <path
        d="M2.3301 5.19592C1.85636 4.93688 1.34983 4.74297 0.824219 4.61945L0.847748 4.51357H3.11834C3.43598 4.51357 3.68304 4.63121 3.7654 4.94886L4.25951 7.31357L4.41245 8.01945L5.80069 4.52533H7.30657L5.07128 9.64298H3.58892L2.3301 5.17239V5.19592ZM8.41245 9.66651H7.00069L7.88304 4.52533H9.29481L8.41245 9.66651ZM13.5536 4.65474L13.3654 5.77239L13.236 5.71357C12.9889 5.60768 12.6477 5.5018 12.1772 5.51357C11.6125 5.51357 11.3654 5.7371 11.3536 5.96063C11.3536 6.19592 11.6713 6.34886 12.1536 6.59592C12.9772 6.94886 13.3536 7.40768 13.3536 7.99592C13.3419 9.05474 12.3772 9.7371 10.883 9.7371C10.2477 9.7371 9.63598 9.61945 9.30657 9.47827L9.49481 8.31357L9.69481 8.39592C10.1536 8.59592 10.4477 8.67827 11.0242 8.67827C11.4242 8.67827 11.8595 8.51357 11.8713 8.17239C11.8713 7.94886 11.683 7.78415 11.1301 7.5371C10.6007 7.27827 9.88304 6.86651 9.89481 6.12533C9.89481 5.1371 10.8948 4.43121 12.283 4.43121C12.836 4.43121 13.283 4.54886 13.5536 4.65474ZM15.436 7.85474H16.6125L16.2948 6.36063L16.1889 5.91357L16.0125 6.41945L15.4477 7.85474H15.436ZM17.2007 4.52533L18.3301 9.66651H17.0125L16.8477 8.9018H15.036L14.7301 9.66651H13.2477L15.3536 4.96063C15.5066 4.60768 15.7536 4.5371 16.0948 4.5371H17.1889V4.52533H17.2007Z"
        fill="#1434CB"
      />
    </svg>
  );
}
